module.exports = __webpack_public_path__ + "img/tarjeta-premium-world.f72a908c.webp";